import React, { useEffect, useRef } from 'react';
import { StyledMessageContainer } from './ConversationArea.styled';
import LoadingMessage from './messageitem/LoadingMessage';
import MessageItem from './messageitem/MessageItem';
import { ChatMessage } from '../../types/Message.types';



interface ConversationAreaProps {
  messages: ChatMessage[];
  isLoading?: boolean;
}

const ConversationArea: React.FC<ConversationAreaProps> = ({ messages, isLoading }) => {
  const bottomRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    bottomRef?.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);
  return (
    <StyledMessageContainer>
      {messages.map((msg, index) => (
        <MessageItem key={index} msg={msg} index={index} />
      ))}
      {isLoading && <LoadingMessage />}
      <div ref={bottomRef} />
    </StyledMessageContainer>
  );
};

export default ConversationArea;